import type { Layout } from "../../../types";
import margin from "./margin.module.scss";
import bigMargin from "./big-margin.module.scss";
import horizontal2 from "./horizontal-2.module.scss";
import vertical2 from "./vertical-2.module.scss";
import horizontal2Text from "./horizontal-2-text.module.scss";
import vertical2Text from "./vertical-2-text.module.scss";
import photos3 from "./photos-3.module.scss";
import photos4 from "./photos-4.module.scss";
import rectangleText from "./rectangle-text.module.scss";
import round from "./round.module.scss";

const layouts: Layout[] = [
  {
    value: "margin",
    label: "Avec marge",
    countPhotos: 1,
    countLabels: 0,
    style: margin,
    photoAspectRatios: [1],
  },
  {
    value: "big-margin",
    label: "Marge large",
    countPhotos: 1,
    countLabels: 0,
    style: bigMargin,
    photoAspectRatios: [1],
  },
  {
    value: "horizontal-2",
    label: "Séparateur horizontal",
    countPhotos: 2,
    countLabels: 0,
    style: horizontal2,
    photoAspectRatios: [2.08, 2.08],
  },
  {
    value: "vertical-2",
    label: "Séparateur vertical",
    countPhotos: 2,
    countLabels: 0,
    style: vertical2,
    photoAspectRatios: [0.48, 0.48],
  },
  {
    value: "horizontal-2-text",
    label: "Horizontal & Texte",
    countPhotos: 2,
    countLabels: 2,
    style: horizontal2Text,
    photoAspectRatios: [1, 1],
    labelMaxLength: 75,
  },
  {
    value: "vertical-2-text",
    label: "Séparateur vertical",
    countPhotos: 2,
    countLabels: 2,
    style: vertical2Text,
    photoAspectRatios: [0.59, 0.59],
    labelMaxLength: 50,
  },
  {
    value: "photos-3",
    label: "Trois photos",
    countPhotos: 3,
    countLabels: 0,
    style: photos3,
    photoAspectRatios: [1, 1, 2.08],
  },
  {
    value: "photos-4",
    label: "Quatre photos",
    countPhotos: 4,
    countLabels: 0,
    style: photos4,
    photoAspectRatios: [1, 1, 1, 1],
  },
  {
    value: "rectangle-text",
    label: "Photo et texte",
    countPhotos: 1,
    countLabels: 1,
    style: rectangleText,
    photoAspectRatios: [2.54],
    labelMaxLength: 150,
  },
  {
    value: "round",
    label: "Photo arrondie",
    countPhotos: 1,
    countLabels: 0,
    style: round,
    photoAspectRatios: [1],
    photoCropShapes: ["round"],
  },
];

export default layouts;
